import React, {Component} from 'react'
import {Panel} from '@sabre/spark-react'
import ScreenTemplate from 'shared/components/ScreenTemplate'
import SigchartToolbar from './Toolbar'
import SigchartTable from './SigchartTable'
import {openUrl} from 'shared/utils/openUrl'

export default class Sigcharts extends Component {

    pageTitle = 'SigCharts'

    constructor(props, context) {
        super(props, context)

        this.state = {
            filters: true
        }

        this.actions = {
            onSelectDocument: (params) => this.onSelectDocument(params),
            onDisplaySigchart: (params) => this.onDisplaySigchart(params),
            onShowFilters: () => this.onShowFilters()
        }
    }

    render() {
        let message = this.props.error
            ? {type: "warning", title: this.props.error.title, text: this.props.error.text}
            : undefined
        return (
            <ScreenTemplate
                login={this.props.username || 'unknown'}
                activeMenuItem={this.pageTitle}
                actions={{onSignOut: this.props.signOut}}
                message={message}>
                <div className="col-xs-12">
                    <Panel>
                        <Panel.Content>
                            <SigchartToolbar actions={this.actions} selectedIds={this.props.selectedIds}/>
                            <SigchartTable actions={this.actions} data={this.props.data} filters={this.state.filters}
                                           isLoading={this.props.isLoading} selectedIds={this.props.selectedIds}
                                           loadingIds={this.props.loadingIds}
                            />
                        </Panel.Content>
                    </Panel>
                </div>
            </ScreenTemplate>
        )
    }

    componentDidMount() {
        this.onGetSigchartList()
    }

    componentWillUnmount() {
        if (this.props.blobUrl !== undefined)
            URL.revokeObjectURL(this.props.blobUrl)
        this.props.actions.resetError()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.blobUrl !== undefined &&
            nextProps.blobUrl !== this.props.blobUrl) {
            openUrl(nextProps.blobUrl)
        }
    }

    onGetSigchartList() {
        this.props.actions.getSigchartList()
    }

    onSelectDocument(params) {
        this.props.actions.selectDocument(params)
    }

    onDisplaySigchart(params) {
        this.props.actions.getSigchart(params)
    }

    onShowFilters() {
        this.setState({filters: !this.state.filters})
    }
}


// WEBPACK FOOTER //
// ./src/screens/sigcharts/components/index.js